

import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { Container, Row, Col, NavItem, Table } from 'react-bootstrap';
import "./preChippingPopOver.css";
import { useState } from 'react';
import { handleNumberFieldFocus } from '../../../common/commonFunction';
function PreChippingPopOver(props) {

  const [bundle, setBundle] = useState(props.bundle);

  const handleChange = (e) => {

    setBundle({

      ...bundle,

      [e.target.name]: e.target.value,

    });
  }

  const saveChange = (e) => {
    e.preventDefault();
    props.updateBundleData(bundle);
    props.onClose();
  }

  return (
    <div className="pre-chipping-popup-container">
      <div className="bamboo-text">Raw Bamboo Issue</div>
      <Container fluid>
        <Row>
          <form onSubmit={(e)=>saveChange(e)}>
            <Col xs={12} md={9}>
              <div className="consignment-pick-up-consignment-label" >Moisture</div>
              <input min= "0" required className='consignment-pick-up-textfields' value={bundle.preChippingMoisture} name="preChippingMoisture" onChange={(e) => handleChange(e)} type="number" onFocus={handleNumberFieldFocus} step=".01" />
            </Col>
            <Col xs={12} md={9}>
              <div className="consignment-pick-up-consignment-label" >Weight</div>
              <input min= "0" required className='consignment-pick-up-textfields' value={bundle.preChippingWeight} name="preChippingWeight" onChange={(e) => handleChange(e)} type="number" onFocus={handleNumberFieldFocus} step=".01"/>
            </Col>
            <Row>
              <Col xs={12} md={6}>
                <div class="pre-chipping-popover-div">
                  <button className='pre-chipping-popover-Btn' type='submit'>Submit</button>
                </div>
              </Col>
            </Row>
          </form>
        </Row>
      </Container>
    </div>
  );
};
export default PreChippingPopOver;
